import { render, staticRenderFns } from "./selectQuickMenu.vue?vue&type=template&id=b959bf06&scoped=true"
import script from "./selectQuickMenu.vue?vue&type=script&lang=js"
export * from "./selectQuickMenu.vue?vue&type=script&lang=js"
import style0 from "./selectQuickMenu.vue?vue&type=style&index=0&id=b959bf06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b959bf06",
  null
  
)

export default component.exports